// extracted by mini-css-extract-plugin
export var standaloneTable = "_ej-0";
export var standaloneTableWithBodyFill = "_ej-1";
export var withExtraHeader = "_ej-2";